export { default as StixContainer } from './StixContainer'
export { default as Stix } from './Stix'
export { default as StixInfos } from './StixInfos'
export { default as StixHeader } from './StixHeader'
export { default as StixWrapper } from './StixWrapper'
export { default as SideBar } from './SideBar'
export { default as StixStars } from './StixStars'
export { default as reducer } from './reducer'



// WEBPACK FOOTER //
// ./src/features/Stix/index.js